<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">{{ currentNews.date }}</p>
    <div class="content">
      <template v-for="(p, index) in paragraphs" :key="index">
        <!-- 文字内容 -->
        <div class="content-section">
          <div class="text-block">
            <p v-html="highlightText(p)"></p>
          </div>
        </div>

        <!-- 在特定段落后插入图片 (仅针对中文) -->
        <template v-if="isZh">
          <div v-if="index === 3" class="content-section image-section">
            <div class="image-container">
              <img :src="currentNews.other?.picture1?.url">
              <p class="image-caption">图：全尺寸环向场磁体测试现场</p>
            </div>
          </div>
          <div v-else-if="index === 11" class="content-section image-section">
            <div class="image-container">
              <img :src="currentNews.other?.picture2?.url">
              <p class="image-caption">图：测试结果</p>
            </div>
          </div>
          <div v-else-if="index === 23" class="content-section image-section">
            <div class="image-container">
              <img :src="currentNews.other?.picture3?.url">
              <p class="image-caption">图：信号监控系统界面</p>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();
const isZh = computed(() => langStore.currentLang.startsWith('zh'));

const currentNews = computed(() => {
  const translationData = isZh.value ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  return newsList.find((news: any) => news.id === 'startorus-fusion-magnet-test') || {};
});

const paragraphs = computed(() => {
  return currentNews.value.content?.split('---') || [];
});

const highlightText = (text: string) => {
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlighted-text">$1</span>');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto; 
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  line-height: 1.8;
  margin-bottom: 10px;
  white-space: pre-wrap;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
  max-width: 800px;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

.image-caption {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  background-color: transparent;
  padding: 2px 4px;
  border-radius: 3px;
  display: block;
  margin-top: 15px;
  font-size: 1.1em;
}
</style>
